var _rect, _rect2, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBonus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  fill: "#fff",
  rx: 17
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  fill: "url(#bonus_svg__a)",
  fillOpacity: 0.5,
  rx: 17
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#bonus_svg__b)",
  d: "M8.532 11.829a1.3 1.3 0 0 1 1.713-.63l8.867 3.997c.649.293.935 1.049.638 1.69l-3.739 8.068a1.3 1.3 0 0 1-1.713.63l-8.867-3.997a1.27 1.27 0 0 1-.638-1.69z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#bonus_svg__c)",
  d: "M15.451 8.686a1.305 1.305 0 0 1 1.828-.024l6.726 6.458c.512.491.523 1.298.024 1.802l-8.276 8.386a1.305 1.305 0 0 1-1.828.024L7.2 18.875a1.26 1.26 0 0 1-.024-1.803z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#bonus_svg__d)",
  d: "M23.838 9.607a1.3 1.3 0 0 1 1.73.582l3.623 7.278c.315.632.05 1.396-.59 1.706l-13.185 6.386a1.3 1.3 0 0 1-1.73-.583l-3.624-7.278a1.267 1.267 0 0 1 .59-1.706z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#bonus_svg__e)",
  d: "m20.135 11.403 3.878 3.723c.512.492.523 1.298.025 1.803l-8.277 8.386a1.3 1.3 0 0 1-.281.216l-.065.03a1.3 1.3 0 0 1-1.73-.581l-3.623-7.278a1.267 1.267 0 0 1 .59-1.706z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "bonus_svg__a",
  x1: 0,
  x2: 44.728,
  y1: -8.5,
  y2: 3.034,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4FDA6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.203,
  stopColor: "#B3E27E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.794,
  stopColor: "#A8EAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.975,
  stopColor: "#4DCFFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bonus_svg__b",
  x1: 13.475,
  x2: 9.353,
  y1: 25.017,
  y2: 11.576,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD540"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFA800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bonus_svg__c",
  x1: 16.007,
  x2: 16.445,
  y1: 8.486,
  y2: 25.367,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#C0E671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5CA500"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bonus_svg__d",
  x1: 24.613,
  x2: 22.849,
  y1: 10.728,
  y2: 25.669,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#75CFF4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0094C2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bonus_svg__e",
  x1: 22.896,
  x2: 17.299,
  y1: 12.315,
  y2: 25.746,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#289DC6",
  stopOpacity: 0.29
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#289DC6",
  stopOpacity: 0
})))));
export default SvgBonus;